var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#9277FF",
    fillOpacity: 0.4,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78499 14.9921H13.1872C13.7966 14.9921 14.2788 15.5807 14.2872 16.3129L14.2976 17.2515H3.68079L3.68499 16.3129C3.79539 15.5127 4.33799 14.9921 4.78499 14.9921Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0074 4.3412C8.725 4.3412 8.4418 4.4472 8.3052 4.662L6.323 8.4692L3.0636 5.3432C2.9114 5.2182 2.7062 5.1662 2.4998 5.1756C2.1562 5.191 1.8102 5.3746 1.7074 5.6692L3.7562 13.1966C3.978 13.5248 3.9916 13.981 4.7102 13.981H13.273C13.9916 13.981 13.9928 13.5434 14.2272 13.1966L16.2752 5.6692C16.173 5.3746 15.8272 5.191 15.4834 5.1756C15.277 5.1664 15.0718 5.2182 14.92 5.3432L11.6812 8.4536L9.7084 4.662C9.5718 4.4472 9.2896 4.3412 9.0074 4.3412Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81028 4.55249C2.40111 4.55249 2.88008 4.04738 2.88008 3.42429C2.88008 2.8012 2.40111 2.29609 1.81028 2.29609C1.21944 2.29609 0.740479 2.8012 0.740479 3.42429C0.740479 4.04738 1.21944 4.55249 1.81028 4.55249Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99196 3.39089C9.68287 3.39089 10.243 2.80053 10.243 2.07229C10.243 1.34404 9.68287 0.753685 8.99196 0.753685C8.30106 0.753685 7.74097 1.34404 7.74097 2.07229C7.74097 2.80053 8.30106 3.39089 8.99196 3.39089Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2368 3.42434C17.2368 4.04714 16.7576 4.55254 16.1668 4.55254C15.5754 4.55254 15.0972 4.04714 15.0972 3.42434C15.0972 2.80134 15.5754 2.29634 16.1668 2.29634C16.7576 2.29614 17.2368 2.80134 17.2368 3.42434Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.426582a021cbc527984ad6b78c0f06c6.svg";
export { ForwardRef as ReactComponent };